// ====== Airtable config ======
const airtableBaseId = 'appkFOBCwz3KcfnJj';
const airtableApiKey = 'patwXC2RjES5kjtpu.f912eb1093194e009f8f0abe40a6156c71750e24b8e599a27f6bc9a98ea2c37d';
const airtableCarTableName = '車両項目DB';
const airtableProductTableNames = ['純正項目DB', '社外項目DB'];

// ====== Navigation stack ======
window.WUWA_NAV = {
  stack: [],
  _restoring: false,
  push(fn) {
    if (this._restoring) return;
    if (typeof fn === 'function') {
      this.stack.push(fn);
      this.updateBtn();
    }
  },
  back() {
    const fn = this.stack.pop();
    if (typeof fn === 'function') {
      this._restoring = true;
      try { fn(); } finally { this._restoring = false; }
    }
    this.updateBtn();
  },
  clear() {
    this.stack.length = 0;
    this.updateBtn();
  },
  updateBtn() {
    const btn = document.getElementById('wuwa-back-btn');
    if (btn) btn.style.display = this.stack.length ? 'inline-flex' : 'none';
  }
};

// ====== Runtime context ======
window.WUWA_CTX = {
  makerName: null,
  vehicleNames: null,
  vehicleName: null,
  lastVehicleRecords: null,
  searchHistory: new Map(),
  flow: null
};

// ====== Back button mount ======
document.addEventListener('DOMContentLoaded', function () {
  if (document.getElementById('wuwa-back-btn')) return;
  const btn = document.createElement('button');
  btn.id = 'wuwa-back-btn';
  btn.type = 'button';
  btn.className = 'btn btn--secondary';
  btn.textContent = '← 戻る';
  btn.style.cssText = 'position:sticky;top:8px;left:0;z-index:1;display:none;margin-bottom:8px;';
  const host = document.getElementById('car-search-results');
  const wrapper = host ? host.parentElement : document.body;
  if (wrapper && host) wrapper.insertBefore(btn, host); else document.body.prepend(btn);
  btn.addEventListener('click', () => window.WUWA_NAV.back());
});

// ====== Utils ======
function airEsc(v) { return String(v ?? '').replace(/'/g, "\\'"); }
function normalizeVariantValue(s) { return String(s || '').trim().toLowerCase().replace(/[－–—]/g, '-').replace(/[\/／]/g, '').replace(/[-\s,，、]/g, ''); }
function splitOptionValueAtoms(raw, optionName = '') {
  const sep = optionName === 'タイヤサイズ' ? /[,\u3001\uFF0C、，・･]+/ : /[,\u3001\uFF0C、，・･\/／]+/;
  return String(raw || '').split(sep).map(s => s.trim()).filter(Boolean);
}
function normalizeHandle(input) {
  if (!input) return "";
  return encodeURIComponent(String(input).trim().replace(/\s+/g, '-').replace(/　+/g, '-').replace(/\//g, '-').replace(/\+/g, '').toLowerCase());
}
function toShopifyHandle(h) {
  let s = String(h || '').trim();
  try { s = decodeURIComponent(s); } catch (e) { }
  if (typeof s.normalize === 'function') s = s.normalize('NFKC');
  s = s.toLowerCase();
  s = s.replace(/[\s\u3000]+/g, '-').replace(/[\/\\]+/g, '-').replace(/[＋+]+/g, '-').replace(/[_·･・・。、，,。．.]+/g, '-').replace(/[&]+/g, '-');
  s = s.replace(/[^a-z0-9-]+/g, '-');
  s = s.replace(/-+/g, '-').replace(/^-|-$/g, '');
  return s;
}
function resolveProductHandle(record, tableName) {
  const f = record?.fields || {};
  const explicit = f['データ連携用(handle)'] || f['handle'] || f['Shopify Handle'] || f['Shopify handle'] || f['shopify_handle'] || f['ハンドル'];
  if (explicit) return String(explicit).trim();
  const raw = tableName === '純正項目DB' ? (f['商品品番'] || f['管理用商品品番']) : (f['管理用商品品番'] || f['商品品番']);
  return normalizeHandle(raw);
}
function clearSearchNotices(carDetailId) {
  const root = document.getElementById(carDetailId);
  if (!root) return;
  root.querySelectorAll('.centered, .u-searching, .u-searching--error').forEach(el => el.remove());
}
function getAllDescendantHandles(handle) {
  const target = (handle || '').toLowerCase();
  function findNode(nodes) {
    for (const node of nodes) {
      if ((node.handle || '').toLowerCase() === target) return node;
      if (node.children) {
        const found = findNode(node.children);
        if (found) return found;
      }
    }
    return null;
  }
  const node = findNode(window.categoryData || []);
  const result = [target];
  if (node && node.children) {
    (function walk(children) {
      children.forEach(c => {
        const h = (c.handle || '').toLowerCase();
        result.push(h);
        if (c.children && c.children.length) walk(c.children);
      });
    })(node.children);
  }
  return result;
}
function focusOnCar(uniqueId) {
  const list = document.querySelector('.car-details');
  const node = document.getElementById(uniqueId);
  if (!list || !node) return;
  list.innerHTML = '';
  list.appendChild(node);
  setTimeout(() => node.scrollIntoView({ behavior: 'smooth', block: 'start' }), 300);
}
function getTireMidCategories() {
  const cats = window.categoryData || [];
  for (const c of cats) {
    const title = (c.title || '').trim();
    const handle = (c.handle || '').toLowerCase();
    if (title === 'タイヤ' || handle === 'tire') {
      const children = Array.isArray(c.children) ? c.children : [];
      return children.map(ch => ({ handle: (ch.handle || '').toLowerCase(), title: ch.title || '' })).filter(x => x.handle && x.title)
    }
  }
  return [];
}
function setActiveMakerButton(makerName) {
  const wrap = document.getElementById('maker-buttons');
  if (!wrap) return;
  wrap.querySelectorAll('.maker-button').forEach(btn => {
    if (btn.textContent.trim() === String(makerName || '').trim()) { btn.classList.add('active'); } else { btn.classList.remove('active'); }
  });
}

// ====== Category filters ======
function setupCategoryFilters(uniqueId) {
  const categoryContainer = document.getElementById(`category-container-${uniqueId}`);
  const categorySelect = document.getElementById(`category-filter-${uniqueId}`);
  if (!window.categoryData || !categorySelect || !categoryContainer) return;

  categoryContainer.innerHTML = "";
  const HIDE_TOP_TITLES = new Set(['タイヤ', 'バッテリー']);
  const HIDE_TOP_HANDLES = new Set(['tire', 'battery']);
  categorySelect.innerHTML = '<option value="">すべてのカテゴリ</option>';

  (window.categoryData || []).forEach(category => {
    const title = (category.title || '').trim();
    const handle = (category.handle || '').toLowerCase();
    if (HIDE_TOP_TITLES.has(title) || HIDE_TOP_HANDLES.has(handle)) return;
    const option = document.createElement("option");
    option.value = category.handle;
    option.textContent = category.title;
    categorySelect.appendChild(option);
  });

  categorySelect.addEventListener("change", function () {
    const selectedCategoryHandle = this.value;
    const selectedCategoryData = (window.categoryData || []).find(cat => cat.handle === selectedCategoryHandle);
    const existingSub = document.getElementById(`subcategory-container-${uniqueId}`);
    const existingSub2 = document.getElementById(`subsubcategory-container-${uniqueId}`);
    if (existingSub) existingSub.remove();
    if (existingSub2) existingSub2.remove();
    if (selectedCategoryData && selectedCategoryData.children?.length > 0) {
      addSubcategorySelect(uniqueId, selectedCategoryData.children, categoryContainer, selectedCategoryData);
    }
  });
}
function addSubcategorySelect(uniqueId, children, parentContainer, parentCategory) {
  let existing = document.getElementById(`subcategory-container-${uniqueId}`);
  if (existing) existing.remove();
  const container = document.createElement("div");
  container.id = `subcategory-container-${uniqueId}`;
  container.classList.add("subcategory-container");
  parentContainer.appendChild(container);

  const parentTitle = (parentCategory?.title || '').trim();
  const parentHandle = (parentCategory?.handle || '').toLowerCase();

  const filteredChildren = (children || []).filter(c => {
    const t = (c.title || '').trim();
    const h = (c.handle || '').toLowerCase();
    if ((parentTitle === 'オイル' || parentHandle === 'oil') && (t === 'エンジンオイル' || h === 'engine-oil')) return false;
    if ((parentTitle === 'エレクトリカル' || parentHandle === 'electrical' || parentHandle === 'エレクトリカル') && (t === 'ワイパーブレード' || t === 'ワイヤーブレード' || h === 'wiper-blade')) return false;
    return true;
  });

  const select = document.createElement("select");
  select.id = `subcategory-filter-${uniqueId}`;
  select.innerHTML = `<option value="">すべてのサブカテゴリ</option>`;
  filteredChildren.forEach(c => {
    const o = document.createElement("option");
    o.value = c.handle;
    o.textContent = c.title;
    select.appendChild(o);
  });
  container.appendChild(select);

  select.addEventListener("change", () => {
    const oldSub2 = document.getElementById(`subsubcategory-container-${uniqueId}`);
    if (oldSub2) oldSub2.remove();
    const data = filteredChildren.find(c => c.handle === select.value);
    if (data?.children?.length) {
      addSubSubcategorySelect(uniqueId, data.children, container);
    }
  });
}
function addSubSubcategorySelect(uniqueId, children, parentContainer) {
  let c = document.getElementById(`subsubcategory-container-${uniqueId}`);
  if (!c) {
    c = document.createElement("div");
    c.id = `subsubcategory-container-${uniqueId}`;
    c.classList.add("subsubcategory-container");
    parentContainer.appendChild(c);
  }
  const s = document.createElement("select");
  s.id = `subsubcategory-filter-${uniqueId}`;
  s.innerHTML = '<option value="">すべての小カテゴリ</option>';
  children.forEach(ssc => {
    const o = document.createElement("option");
    o.value = ssc.value || ssc.handle;
    o.textContent = ssc.title;
    s.appendChild(o);
  });
  c.appendChild(s);
}

// ====== UI helpers ======
function generateCarDetailField(label, value) {
  return value ? `<div class="car-details__tableCell"><p class="car-details__tableHead">${label}</p><p class="car-details__tableData">${value}</p></div>` : '';
}
function filterProductsByCategory(carDetailId, selectedCategory) {
  const relatedProductsContainer = document.querySelector(`#${carDetailId} .car-details__relatedProducts`);
  const productCards = relatedProductsContainer.querySelectorAll('.card');
  productCards.forEach(card => {
    const productCategory = card.getAttribute('data-category');
    card.style.display = (selectedCategory === "" || productCategory === selectedCategory) ? 'block' : 'none';
  });
}

// ====== Search history helpers ======
function getSearchStack(carId) {
  if (!window.WUWA_CTX.searchHistory.has(carId)) window.WUWA_CTX.searchHistory.set(carId, []);
  return window.WUWA_CTX.searchHistory.get(carId);
}
function hasCurrentSearchResult(carId) {
  const root = document.getElementById(carId);
  if (!root) return false;
  const rel = root.querySelector('.car-details__relatedProducts');
  if (rel && rel.children.length > 0) return true;
  return !!root.querySelector('.centered');
}
function makeSearchRestore(carId) {
  const root = document.getElementById(carId);
  if (!root) return () => { };
  const rel = root.querySelector('.car-details__relatedProducts');
  const html = rel ? rel.innerHTML : '';
  return () => {
    const r = document.getElementById(carId);
    if (!r) return;
    focusOnCar(carId);
    clearSearchNotices(carId);
    const rel2 = r.querySelector('.car-details__relatedProducts');
    if (rel2) rel2.innerHTML = html;
    window.WUWA_NAV.updateBtn();
  };
}
function prepareBackForNewSearch(carId) {
  if (hasCurrentSearchResult(carId)) {
    const stack = getSearchStack(carId);
    stack.push(makeSearchRestore(carId));
    window.WUWA_NAV.push(() => {
      const s = getSearchStack(carId);
      const fn = s.pop();
      if (typeof fn === 'function') fn();
    });
  } else {
    window.WUWA_NAV.push(() => {
      if (Array.isArray(window.WUWA_CTX.lastVehicleRecords) && window.WUWA_CTX.lastVehicleRecords.length) {
        renderVehicleListFromRecords(window.WUWA_CTX.lastVehicleRecords, window.WUWA_CTX.makerName);
      } else if (window.WUWA_CTX.makerName && window.WUWA_CTX.vehicleName) {
        fetchVehiclesByName(window.WUWA_CTX.makerName, window.WUWA_CTX.vehicleName);
      } else {
        const el = document.getElementById('car-search-results');
        if (el) el.innerHTML = '';
      }
    });
  }
}

// ====== Car detail rendering ======
function appendCarDetail(fields, index) {
  const uniqueId = `car-detail-${index}`;
  const carDetailsContainer = document.querySelector('.car-details');
  const imgUrl = fields['車両画像']?.[0]?.url || '//wuwa.jp/cdn/shop/files/no-image.png?v=1730941105';

  const carDetailHtml = `
    <li class="car-detail" id="${uniqueId}">
      <div class="car-details__inner">
        <div class="car-details__imageWrapper">
          <img class="car-details__image" src="${imgUrl}" alt="車両画像" onerror="this.src='//wuwa.jp/cdn/shop/files/no-image.png?v=1730941105'">
        </div>
        <div class="car-details__contents">
          <div class="car-details__table">
            ${generateCarDetailField('メーカー名', fields['メーカー名'])}
            ${generateCarDetailField('車両名', fields['車両名'])}
            ${generateCarDetailField('車両コード', fields['車両コード'])}
            ${generateCarDetailField('識別記号', fields['識別記号'])}
            ${generateCarDetailField('型式', fields['型式'])}
            ${generateCarDetailField('グレード', fields['グレード'])}
            ${generateCarDetailField('排気量', fields['排気量'])}
            ${generateCarDetailField('エンジン型式', fields['エンジン型式'])}
            ${generateCarDetailField('年式', fields['年式'])}
            ${generateCarDetailField('仕様', fields['仕様'])}
            ${(() => {
              const HIDE = new Set(['タイヤ', 'オイル', 'エレクトリカル']);
              let html = '';
              for (let i = 1; i <= 10; i++) {
                const n = fields[`オプション名${i}`];
                const v = fields[`オプション値${i}`];
                if (!n || !v) continue;
                if (HIDE.has(String(n).trim())) continue;
                html += generateCarDetailField(n, v);
              }
              return html;
            })()}
          </div>
        </div>
      </div>
      <div class="car-details__filtersWrapper grid grid-cols-2 gap-6">
        <div class="code-search">
          <label for="category-filter-${uniqueId}">部品カテゴリを選択</label>
          <div class="car-details__filters">
            <select id="category-filter-${uniqueId}" class="filter-dropdown">
              <option value="">すべてのカテゴリ</option>
            </select>
            <div id="category-container-${uniqueId}" class="category-container"></div>
            <div class="car-details__action">
              <button class="car-detail__select-parts btn btn--primary w-full" data-car-id="${fields['車両コード']}">パーツ検索</button>
            </div>
          </div>
        </div>
        <div class="option-search">
          <label for="option-filter-${uniqueId}">タイヤ/エンジンオイル/バッテリー/ワイパーを探す</label>
          <div class="car-details__filters">
            <select id="option-filter-${uniqueId}" class="filter-dropdown">
              <option value="">この車に適合するパーツを選択</option>
            </select>
            <div id="tire-midcategory-container-${uniqueId}" class="tire-midcategory-container" style="display:none;"></div>
            <div class="car-details__action">
              <button class="car-detail__select-option btn btn--secondary w-full" data-car-id="${fields['車両コード']}">検索</button>
            </div>
          </div>
        </div>
      </div>
      <div class="car-details__relatedProducts grid mb-8 md:mb-12 grid-cols-2 small-cards-mobile sm:grid-cols-3 xl:grid-cols-4 small-cards-desktop gap-x-theme gap-y-16"></div>
    </li>`;
  carDetailsContainer.insertAdjacentHTML("beforeend", carDetailHtml);

  const selectPartsButton = document.querySelector(`#${uniqueId} .car-detail__select-parts`);
  if (selectPartsButton) {
    selectPartsButton.addEventListener('click', () => {
      prepareBackForNewSearch(uniqueId);
      handleSelectPartsByCarCode(fields['車両コード'], uniqueId);
      saveSnapshot('productResults');
    });
  }

  if (typeof setupCategoryFilters === "function") { setupCategoryFilters(uniqueId); }

  const optionSelect = document.getElementById(`option-filter-${uniqueId}`);
  const EXCLUDE = new Set(['タイヤ', 'オイル', 'エレクトリカル']);
  for (let i = 1; i <= 10; i++) {
    const name = fields[`オプション名${i}`];
    const value = fields[`オプション値${i}`];
    if (!name || !value) continue;
    if (EXCLUDE.has(String(name).trim())) continue;
    const opt = document.createElement('option');
    opt.value = String(value).trim();
    opt.textContent = `${name}：${value}`;
    opt.dataset.optname = String(name).trim();
    optionSelect.appendChild(opt);
  }
  optionSelect.addEventListener('change', () => {
    const selected = optionSelect.selectedOptions[0];
    const optName = selected?.dataset?.optname || '';
    if (optName === 'タイヤサイズ') { ensureTireMidSelect(uniqueId); } else { removeTireMidSelect(uniqueId); }
  });

  const selectOptionButton = document.querySelector(`#${uniqueId} .car-detail__select-option`);
  if (selectOptionButton) {
    selectOptionButton.addEventListener('click', () => {
      prepareBackForNewSearch(uniqueId);
      clearSearchNotices(uniqueId);
      focusOnCar(uniqueId);
      const selected = document.getElementById(`option-filter-${uniqueId}`).selectedOptions[0];
      const selectedValue = selected?.value || '';
      const optionName = selected?.dataset?.optname || '';
      if (!selectedValue) return;
      const midSel = document.getElementById(`tire-midcategory-filter-${uniqueId}`);
      const tireMidHandle = (optionName === 'タイヤサイズ' && midSel) ? (midSel.value || '').trim().toLowerCase() : '';
      const rel = document.getElementById(uniqueId).querySelector('.car-details__relatedProducts');
      rel.innerHTML = '';
      fetchProductsByOption(uniqueId, optionName, selectedValue, tireMidHandle).then(() => {
        saveSnapshot('productResults');
      });
    });
  }
}

// ====== Option helpers ======
function ensureTireMidSelect(uniqueId) {
  const container = document.getElementById(`tire-midcategory-container-${uniqueId}`);
  if (!container) return;
  const mids = getTireMidCategories();
  if (!mids.length) {
    container.style.display = 'block';
    container.innerHTML = `<small class="text-muted">タイヤの中カテゴリデータがありません</small>`;
    return;
  }
  const optionsHtml = ['<option value="">タイヤの種類を選択</option>'].concat(mids.map(m => `<option value="${m.handle}">${m.title}</option>`)).join('');
  container.style.display = 'block';
  container.innerHTML = `<select id="tire-midcategory-filter-${uniqueId}" class="filter-dropdown">${optionsHtml}</select>`;
}
function removeTireMidSelect(uniqueId) {
  const container = document.getElementById(`tire-midcategory-container-${uniqueId}`);
  if (container) { container.style.display = 'none'; container.innerHTML = ''; }
}

// ====== Product search ======
function handleSelectPartsByCarCode(carCode, uniqueId) {
  focusOnCar(uniqueId);
  fetchProductDetails(carCode, uniqueId);
}
function fetchProductDetails(carCode, carDetailId) {
  const root = document.getElementById(carDetailId);
  const rel = root.querySelector('.car-details__relatedProducts');
  clearSearchNotices(carDetailId);
  rel.innerHTML = '';

  const searchId = `${Date.now()}_${Math.random().toString(36).slice(2)}`;
  root.dataset.searchId = searchId;

  const searching = document.createElement('p');
  searching.className = 'u-searching';
  searching.textContent = '商品を検索中...';
  rel.insertAdjacentElement('beforebegin', searching);

  const categorySelect = document.getElementById(`category-filter-${carDetailId}`);
  const subCategorySelect = document.getElementById(`subcategory-filter-${carDetailId}`);
  const subSubCategorySelect = document.getElementById(`subsubcategory-filter-${carDetailId}`);
  const selectedCategory = categorySelect ? categorySelect.value.trim() : "";
  const selectedSubCategory = subCategorySelect ? subCategorySelect.value.trim() : "";
  const selectedSubSubCategory = subSubCategorySelect ? subSubCategorySelect.value.trim() : "";

  const shownHandles = new Set();
  const airtableTasks = [];
  const detailTasks = [];

  airtableProductTableNames.forEach((tableName) => {
    const formula = `SEARCH("${airEsc(carCode)}",{適合車両コード})`;
    const url = `https://api.airtable.com/v0/${airtableBaseId}/${tableName}?filterByFormula=${encodeURIComponent(formula)}`;
    const p = fetch(url, { headers: { Authorization: `Bearer ${airtableApiKey}` } })
      .then(r => r.json())
      .then(data => {
        (data.records || []).forEach(record => {
          const rawHandle = resolveProductHandle(record, tableName);
          const handle = toShopifyHandle(rawHandle);
          if (!handle || shownHandles.has(handle)) return;
          shownHandles.add(handle);
          const d = fetchShopifyProductDetails(handle, carDetailId, selectedCategory, selectedSubCategory, selectedSubSubCategory, searchId).catch(() => { });
          detailTasks.push(d);
        });
      }).catch(() => { });
    airtableTasks.push(p);
  });

  Promise.allSettled(airtableTasks)
    .then(() => Promise.allSettled(detailTasks))
    .then(() => {
      if (root.dataset.searchId !== searchId) return;
      if (searching) searching.remove();
      const cards = rel.querySelectorAll('.card');
      if (cards.length === 0) {
        rel.insertAdjacentHTML('beforebegin', `<div class="centered"><p class="card__title font-bold">この車両に適合するパーツが見つかりませんでした</p></div>`);
      }
    });
}
function fetchShopifyProductDetails(productHandle, carDetailId, rawCategory, rawSubCategory, rawSubSubCategory, searchId) {
  if (!productHandle) { return Promise.resolve(false); }

  const selectedCategory = (rawCategory || '').trim().toLowerCase();
  const selectedSubCategory = (rawSubCategory || '').trim().toLowerCase();
  const selectedSubSubCategory = (rawSubSubCategory || '').trim().toLowerCase();
  const urlHandle = toShopifyHandle(productHandle);

  return fetch(`/products/${urlHandle}.js`)
    .then(response => { if (!response.ok) throw new Error('Product not found'); return response.json(); })
    .then(product => {
      const root = document.getElementById(carDetailId);
      if (!root || root.dataset.searchId !== searchId) return false;

      const productCategories = [product.metafields?.custom?.category || "", product.metafields?.custom?.sub_category || "", product.type || "", ...(product.collections || []).map(col => col.handle), ...(product.tags || []).map(tag => tag)]
        .map(cat => (cat || '').trim().toLowerCase()).filter(Boolean);

      let filterHandles = [];
      if (selectedSubSubCategory) {
        filterHandles = [selectedSubSubCategory];
      } else if (selectedSubCategory) {
        filterHandles = getAllDescendantHandles(selectedSubCategory);
      } else if (selectedCategory) {
        filterHandles = getAllDescendantHandles(selectedCategory);
      }
      const isCategoryMatch = filterHandles.length === 0 || productCategories.some(prodCat => filterHandles.includes(prodCat));
      if (!isCategoryMatch) return false;

      const rel = root.querySelector('.car-details__relatedProducts');
      if (rel.querySelector(`a.card[href="/products/${product.handle}"]`)) return true;

      const imgSrc = (product.images && product.images.length) ? product.images[0] : '//wuwa.jp/cdn/shop/files/no-product-image.png?v=1730941105';
      const productHtml = `<a class="card" href="/products/${product.handle}" data-category="${productCategories.join(' ')}"><div class="card__media"><img class="img-fit" loading="lazy" src="${imgSrc}" alt="${product.title}"></div><div class="card__info"><p class="card__title font-bold">${product.title}</p><div class="card__price theme-money">¥${(product.price / 100).toLocaleString()} <small>(税込)</small></div></div></a>`;
      rel.insertAdjacentHTML('beforeend', productHtml);
      return true;
    });
}

// ====== Option-based product search ======
function fetchProductsByOption(carDetailId, optionName, optionValue, tireMidHandle = '') {
  const root = document.getElementById(carDetailId);
  if (!root) return Promise.resolve();
  clearSearchNotices(carDetailId);
  const rel = root.querySelector(".car-details__relatedProducts");
  rel.innerHTML = "";

  const searching = document.createElement("p");
  searching.className = "u-searching";
  searching.textContent = "オプションで検索中…";
  rel.insertAdjacentElement("beforebegin", searching);

  const tokens = String(optionValue || "").split(/[,\u3001\uFF0C]/).map(s => s.trim()).filter(Boolean);
  if (tokens.length === 0) {
    searching.remove();
    rel.insertAdjacentHTML("beforebegin", `<div class="centered"><p class="card__title font-bold">該当する商品が見つかりませんでした。</p></div>`);
    return Promise.resolve();
  }

  const containsRaw = (f, token) => `FIND('${airEsc(token)}', ${f})>0`;
  const perTokenOR = (t) => {
    const fields = ['{オプション値1}', '{オプション値2}', '{オプション値3}'];
    return `OR(${fields.map(f => containsRaw(f, t)).join(',')})`;
  };
  const formula = tokens.length === 1 ? perTokenOR(tokens[0]) : `OR(${tokens.map(perTokenOR).join(',')})`;
  const url = `https://api.airtable.com/v0/${airtableBaseId}/社外項目DB?filterByFormula=${encodeURIComponent(formula)}`;

  return fetch(url, { headers: { Authorization: `Bearer ${airtableApiKey}` } })
    .then(r => r.json())
    .then(data => {
      searching.remove();
      const records = (data && data.records) || [];
      if (records.length === 0) {
        rel.insertAdjacentHTML("beforebegin", `<div class="centered"><p class="card__title font-bold">該当する商品が見つかりませんでした。</p></div>`);
        return;
      }
      const seen = new Set();
      const tasks = records.map(rec => {
        if (!airtableRecordMatchesExact(rec, tokens, optionName)) return Promise.resolve(false);
        const rawHandle = resolveProductHandle(rec, '社外項目DB');
        const handle = toShopifyHandle(rawHandle);
        if (!handle || seen.has(handle)) return Promise.resolve(false);
        seen.add(handle);
        return fetchShopifyProductDetailsForOption(handle, carDetailId, optionName, tokens, tireMidHandle);
      });
      return Promise.all(tasks).then(results => {
        const any = results.some(Boolean);
        if (!any) {
          rel.insertAdjacentHTML("beforebegin", `<div class="centered"><p class="card__title font-bold">該当する商品が見つかりませんでした。</p></div>`);
        }
      });
    })
    .catch(() => {
      searching.remove();
      rel.insertAdjacentHTML("beforebegin", `<p class="u-searching u-searching--error">オプション検索でエラーが発生しました</p>`);
    });
}
function airtableRecordMatchesExact(rec, uiTokens, optionName = '') {
  const f = rec?.fields || {};
  const cols = ['オプション値1', 'オプション値2', 'オプション値3'];
  const tokenNorms = uiTokens.map(normalizeVariantValue);
  const fieldHasExact = (val) => {
    const parts = (Array.isArray(val) ? val : splitOptionValueAtoms(val, optionName)).map(s => normalizeVariantValue(s));
    return parts.some(p => tokenNorms.includes(p));
  };
  return cols.some(c => fieldHasExact(f[c]));
}
async function fetchShopifyProductDetailsForOption(productHandle, carDetailId, optionName, tokens, tireMidHandle = '') {
  const urlHandle = toShopifyHandle(productHandle);
  const res = await fetch(`/products/${urlHandle}.js`);
  if (!res.ok) return false;

  const product = await res.json();
  const name = String(optionName || '').trim();
  const options = Array.isArray(product.options) ? product.options : [];
  const idx = options.findIndex(o => o && String(o).toLowerCase() === name.toLowerCase());
  const tokenNorms = tokens.map(normalizeVariantValue);

  const variantMatchesToken = (v) => {
    if (idx >= 0) {
      const atoms = splitOptionValueAtoms(v[`option${idx + 1}`], name).map(normalizeVariantValue);
      return tokenNorms.some(t => atoms.includes(t));
    } else {
      const candidates = [v.option1, v.option2, v.option3, v.title];
      for (const c of candidates) {
        const atoms = splitOptionValueAtoms(c, name).map(normalizeVariantValue);
        if (tokenNorms.some(t => atoms.includes(t))) return true;
      }
      return false;
    }
  };
  const isValueMatch = Array.isArray(product.variants) && product.variants.some(variantMatchesToken);
  if (!isValueMatch) return false;

  if (name === 'タイヤサイズ' && tireMidHandle) {
    const productCategories = [product.metafields?.custom?.category || "", product.metafields?.custom?.sub_category || "", product.type || "", ...(product.collections || []).map(col => col.handle), ...(product.tags || [])]
      .map(cat => (cat || '').trim().toLowerCase()).filter(Boolean);
    const allowed = getAllDescendantHandles((tireMidHandle || '').toLowerCase());
    const midOk = productCategories.some(pc => allowed.includes(pc));
    if (!midOk) return false;
  }

  const rel = document.getElementById(carDetailId).querySelector('.car-details__relatedProducts');
  if (rel.querySelector(`a.card[href="/products/${product.handle}"]`)) return false;

  const imgSrc = (product.images && product.images.length) ? product.images[0] : '//wuwa.jp/cdn/shop/files/no-product-image.png?v=1730941105';
  const productHtml = `<a class="card" href="/products/${product.handle}"><div class="card__media"><img class="img-fit" src="${imgSrc}" alt="${product.title}"></div><div class="card__info"><p class="card__title font-bold">${product.title}</p><div class="card__price theme-money">¥${(product.price / 100).toLocaleString()} <small>(税込)</small></div></div></a>`;
  rel.insertAdjacentHTML('beforeend', productHtml);
  return true;
}

// ====== Category data boot ======
document.addEventListener("DOMContentLoaded", function () {
  const categoryDataDiv = document.getElementById("category-data");
  if (categoryDataDiv) {
    try { window.categoryData = JSON.parse(categoryDataDiv.textContent.trim()); } catch (e) { }
  }
});

// ====== Tabs ======
document.addEventListener('DOMContentLoaded', function () {
  const tabButtons = document.querySelectorAll('.tab-button[data-target]');
  const tabContents = document.querySelectorAll('.tab-content');
  const resultsContainer = document.getElementById('car-search-results');
  const resultsBuckets = new Map();
  let currentTabId = null;

  function getBucket(tabId) { if (!resultsBuckets.has(tabId)) { resultsBuckets.set(tabId, document.createElement('div')); } return resultsBuckets.get(tabId); }
  function stashCurrentResults() {
    if (!currentTabId || !resultsContainer) return;
    const bucket = getBucket(currentTabId);
    while (resultsContainer.firstChild) { bucket.appendChild(resultsContainer.firstChild); }
  }
  function restoreResultsFor(tabId) {
    if (!tabId || !resultsContainer) return;
    const bucket = getBucket(tabId);
    while (bucket.firstChild) { resultsContainer.appendChild(bucket.firstChild); }
  }

  tabButtons.forEach((button) => {
    button.addEventListener('click', function () {
      const nextTabId = button.getAttribute('data-target'); if (!nextTabId) return;
      WUWA_NAV.clear();
      stashCurrentResults();

      tabButtons.forEach((btn) => btn.classList.remove('active'));
      tabContents.forEach((content) => {
        content.classList.remove('active');
        content.querySelectorAll('input').forEach((input) => input.removeAttribute('required'));
      });
      button.classList.add('active');

      const nextContent = document.getElementById(nextTabId);
      if (nextContent) {
        nextContent.classList.add('active');
        nextContent.querySelectorAll('input').forEach((input) => input.setAttribute('required', 'true'));
      }
      currentTabId = nextTabId;
      restoreResultsFor(currentTabId);

      WUWA_CTX.flow = currentTabId;
      saveSnapshot(detectCurrentView());
    });
  });

  if (tabButtons.length > 0) tabButtons[0].classList.add('active');
  if (tabContents.length > 0) {
    const firstTab = tabContents[0];
    firstTab.classList.add('active');
    firstTab.querySelectorAll('input').forEach((input) => input.setAttribute('required', 'true'));
  }
  if (tabButtons.length > 0) { currentTabId = tabButtons[0].getAttribute('data-target') || null; WUWA_CTX.flow = currentTabId; }
});

// ====== Simple cache (maker & vehicle-name only) ======
const Cache = {
  get(key, maxAgeMs) {
    try {
      const raw = localStorage.getItem(key);
      if (!raw) return null;
      const obj = JSON.parse(raw);
      if (!obj || typeof obj !== 'object') return null;
      if (!obj.ts || obj.data === undefined) return null;
      if (Date.now() - obj.ts > maxAgeMs) return null;
      return obj.data;
    } catch { return null; }
  },
  set(key, data) {
    try {
      const payload = JSON.stringify({ ts: Date.now(), data });
      localStorage.setItem(key, payload);
    } catch { }
  }
};
const WEEK_MS = 7 * 24 * 60 * 60 * 1000;
function cacheKeyVehicleNames(maker) { return `wuwa_vehicle_names_${maker}_v2`; }

// ====== Vehicle list render ======
function renderVehicleListFromRecords(records, makerName) {
  const resultsContainer = document.getElementById('car-search-results');
  if (!resultsContainer) return;
  resultsContainer.innerHTML = '<div class="p-tab-head"><h2 class="p-tab-head__title">車両一覧</h2><p class="p-tab-head__text">以下の車両が見つかりました。</p></div><ul class="car-details"></ul>';
  records.forEach((fields, index) => appendCarDetail(fields, index));
  setActiveMakerButton(makerName);
  window.WUWA_NAV.updateBtn();
  saveSnapshot('vehicleList');

  // 車両一覧 → 戻る で車名一覧へ戻れるように1段積む
  WUWA_NAV.push(() => {
    if (Array.isArray(WUWA_CTX.vehicleNames)) {
      window.WUWA_internal?.renderVehicleNameButtons
        ? window.WUWA_internal.renderVehicleNameButtons(WUWA_CTX.vehicleNames, WUWA_CTX.makerName)
        : renderVehicleNameButtons(WUWA_CTX.vehicleNames, WUWA_CTX.makerName);
    } else if (window.WUWA_internal?.fetchVehicleNamesByMaker) {
      window.WUWA_internal.fetchVehicleNamesByMaker(WUWA_CTX.makerName);
    }
  });
  WUWA_NAV.updateBtn();
}

// ====== Maker & vehicle name flows ======
document.addEventListener('DOMContentLoaded', function () {
  const resultsContainer = document.getElementById('car-search-results');
  const makerButtonsContainer = document.getElementById('maker-buttons');

  function loadMakerButtons() {
    const airtableMakerTableName = '自動車メーカー';
    const preferredOrder = ['トヨタ', '日産', '三菱', 'スバル', 'マツダ', 'スズキ', 'ホンダ', 'ダイハツ'];
    const cacheKey = 'wuwa_makers_v2';
    const cached = Cache.get(cacheKey, WEEK_MS);
    if (cached && Array.isArray(cached)) { renderMakerButtons(cached, preferredOrder); return; }

    fetch(`https://api.airtable.com/v0/${airtableBaseId}/${airtableMakerTableName}?fields[]=メーカー名`, { headers: { Authorization: `Bearer ${airtableApiKey}` } })
      .then(r => r.json())
      .then(data => {
        const all = (data.records || []).map(r => r.fields?.['メーカー名']).filter(Boolean);
        const unique = Array.from(new Set(all));
        Cache.set(cacheKey, unique);
        renderMakerButtons(unique, preferredOrder);
      })
      .catch(() => { makerButtonsContainer.innerHTML = '<p>エラーが発生しました。もう一度お試しください。</p>'; });
  }

  function renderMakerButtons(allMakers, preferredOrder) {
    const sortedMakers = preferredOrder.filter(m => allMakers.includes(m));
    const otherMakers = allMakers.filter(m => !preferredOrder.includes(m));
    const finalOrder = [...sortedMakers, ...otherMakers];
    makerButtonsContainer.innerHTML = '';
    if (finalOrder.length === 0) { makerButtonsContainer.innerHTML = '<p>メーカー名が見つかりませんでした。</p>'; return; }

    finalOrder.forEach(makerName => {
      const button = document.createElement('button');
      button.textContent = makerName;
      button.classList.add('maker-button', 'tab-button');
      button.addEventListener('click', () => {
        document.querySelectorAll('.maker-button').forEach(btn => btn.classList.remove('active'));
        button.classList.add('active');
        WUWA_NAV.clear();
        WUWA_CTX = { makerName: makerName, vehicleNames: null, vehicleName: null, lastVehicleRecords: null, searchHistory: new Map(), flow: WUWA_CTX.flow };
        fetchMakerDetails(makerName);
      });
      makerButtonsContainer.appendChild(button);
    });
  }

  function fetchMakerDetails(makerName) {
    resultsContainer.innerHTML = '<p class="u-searching">検索中...</p>';
    fetchVehicleNamesByMaker(makerName);
  }

  function fetchVehicleNamesByMaker(makerName, offset = null, accumulator = []) {
    const key = cacheKeyVehicleNames(makerName);
    const cached = Cache.get(key, WEEK_MS);
    if (!offset && cached && Array.isArray(cached) && cached.length) {
      renderVehicleNameButtons(cached, makerName);
      return;
    }

    const base = `https://api.airtable.com/v0/${airtableBaseId}/${airtableCarTableName}`;
    const params = new URLSearchParams();
    params.append('filterByFormula', `{メーカー名} = '${airEsc(makerName)}'`);
    params.append('fields[]', '車両名');
    params.append('pageSize', '100');
    if (offset) params.append('offset', offset);

    fetch(`${base}?${params.toString()}`, { headers: { Authorization: `Bearer ${airtableApiKey}` } })
      .then(res => { if (!res.ok) throw new Error(); return res.json(); })
      .then(data => {
        (data.records || []).forEach(rec => {
          const name = rec.fields['車両名'];
          if (name) accumulator.push(name);
        });
        if (data.offset) return fetchVehicleNamesByMaker(makerName, data.offset, accumulator);

        const uniqueNames = Array.from(new Set(accumulator));
        const sorted = uniqueNames.sort((a, b) => a.localeCompare(b, 'ja'));
        Cache.set(key, sorted);
        renderVehicleNameButtons(sorted, makerName);
      })
      .catch(() => { resultsContainer.innerHTML = '<p class="u-searching u-searching--error">車両名の取得に失敗しました。</p>'; });
  }

  function renderVehicleNameButtons(names, makerName) {
    WUWA_NAV.push(() => {
      const el = document.getElementById('car-search-results');
      if (el) el.innerHTML = '';
    });

    WUWA_CTX.makerName = makerName;
    WUWA_CTX.vehicleNames = Array.isArray(names) ? names.slice() : [];
    setActiveMakerButton(makerName);

    if (names.length === 0) { resultsContainer.innerHTML = '<p>該当する車両名が見つかりませんでした。</p>'; saveSnapshot('vehicleNames'); return; }

    resultsContainer.innerHTML = `<div class="p-tab-head"><h2 class="p-tab-head__title">車名一覧</h2><p class="p-tab-head__text">車名を選択してください。</p></div><div class="vehicle-names-container"></div>`;
    const container = resultsContainer.querySelector('.vehicle-names-container');
    names.forEach(vehicleName => {
      const btn = document.createElement('button');
      btn.textContent = vehicleName;
      btn.classList.add('vehicle-name-button', 'tab-button');
      btn.addEventListener('click', () => fetchVehiclesByName(makerName, vehicleName));
      container.appendChild(btn);
    });

    window.WUWA_NAV.updateBtn();
    saveSnapshot('vehicleNames');
  }

  function fetchVehiclesByName(makerName, vehicleName) {
    // 戻る：車名一覧へ
    WUWA_NAV.push(() => {
      if (Array.isArray(WUWA_CTX.vehicleNames)) {
        renderVehicleNameButtons(WUWA_CTX.vehicleNames, makerName);
      } else if (window.WUWA_internal?.fetchVehicleNamesByMaker) {
        window.WUWA_internal.fetchVehicleNamesByMaker(makerName);
      } else {
        const el = document.getElementById('car-search-results'); if (el) el.innerHTML = '';
      }
    });

    WUWA_CTX.vehicleName = vehicleName;
    setActiveMakerButton(makerName);

    // 画像リンク切れ対策：車両一覧は毎回Airtableから取得（キャッシュ不使用）
    resultsContainer.innerHTML = '<p class="u-searching">車両を取得中...</p>';
    const filterFormula = `AND({メーカー名}='${airEsc(makerName)}',{車両名}='${airEsc(vehicleName)}')`;
    fetch(`https://api.airtable.com/v0/${airtableBaseId}/${airtableCarTableName}?filterByFormula=${encodeURIComponent(filterFormula)}`, { headers: { Authorization: `Bearer ${airtableApiKey}` } })
      .then(response => response.json())
      .then(data => {
        const recs = (data.records || []).map(r => r.fields);
        if (recs.length > 0) {
          WUWA_CTX.lastVehicleRecords = recs.slice();
          renderVehicleListFromRecords(WUWA_CTX.lastVehicleRecords, makerName);
        } else {
          resultsContainer.innerHTML = '<p>該当する車両が見つかりませんでした。</p>';
          saveSnapshot('vehicleNames');
        }
        WUWA_NAV.updateBtn();
      })
      .catch(() => { resultsContainer.innerHTML = '<p class="u-searching u-searching--error">エラーが発生しました。もう一度お試しください。</p>'; });
  }

  loadMakerButtons();

  // 外部から呼べるよう公開（ブラウザバック復元や戻るで使用）
  window.WUWA_internal = Object.assign(window.WUWA_internal || {}, {
    fetchVehicleNamesByMaker,
    renderVehicleNameButtons
  });
});

// ====== Free text search (型式/型式指定×類別 等) ======
document.addEventListener('DOMContentLoaded', function () {
  const form = document.getElementById('car-search-form');
  const resultsContainer = document.getElementById('car-search-results');

  function isInRange(rangeString, targetValue) {
    if (typeof targetValue !== 'number' || Number.isNaN(targetValue)) return false;
    const norm = String(rangeString || '').replace(/[－–—]/g, '-').split(',').map(s => s.trim()).filter(Boolean);
    for (let r of norm) {
      const [s, e] = r.split('-').map(v => parseInt((v || '').trim(), 10));
      if (!Number.isNaN(s) && !Number.isNaN(e) && targetValue >= s && targetValue <= e) return true;
    }
    return false;
  }

  function fetchCarDetails(searchValue, searchField) {
    WUWA_NAV.push(() => {
      const el = document.getElementById('car-search-results');
      if (el) el.innerHTML = '';
    });

    resultsContainer.innerHTML = '<p class="u-searching">検索中...</p>';
    let filterFormula = '';

    if (searchField === '型式指定番号 × 類別区分番号') {
      const targetValue = parseInt(searchValue.ruibetsuValue, 10);
      filterFormula = `AND({型式指定番号}='${airEsc(searchValue.katashikiValue)}')`;
      fetch(`https://api.airtable.com/v0/${airtableBaseId}/${airtableCarTableName}?filterByFormula=${encodeURIComponent(filterFormula)}`, { headers: { Authorization: `Bearer ${airtableApiKey}` } })
        .then(response => response.json())
        .then(data => {
          const filteredRecords = (data.records || []).filter(record => {
            const rangeString = record.fields['類別区分番号'];
            return isInRange(rangeString, targetValue);
          });
          if (filteredRecords.length > 0) {
            const recs = filteredRecords.map(r => r.fields);
            WUWA_CTX.lastVehicleRecords = recs.slice();
            resultsContainer.innerHTML = '<div class="p-tab-head"><h2 class="p-tab-head__title">車両一覧</h2><p class="p-tab-head__text">以下の車両が見つかりました。</p></div><ul class="car-details"></ul>';
            recs.forEach((fields, index) => appendCarDetail(fields, index));
            saveSnapshot('vehicleList');

            // 車両一覧 → 戻る で車名一覧には戻らない文脈（自由検索）なので空を積む
            WUWA_NAV.push(() => {
              const el = document.getElementById('car-search-results');
              if (el) el.innerHTML = '';
            });

          } else {
            resultsContainer.innerHTML = '<p class="u-searching">一致する車両が見つかりませんでした。</p>';
            saveSnapshot('vehicleNames');
          }
          WUWA_NAV.updateBtn();
        })
        .catch(() => { resultsContainer.innerHTML = '<p class="u-searching u-searching--error">エラーが発生しました。もう一度お試しください。</p>'; });
    } else {
      filterFormula = `{${searchField}}='${airEsc(searchValue)}'`;
      if (searchField === '型式') {
        const normalizedSearchValue = String(searchValue).toLowerCase().replace(/[-\s]/g, '');
        filterFormula = `SEARCH("${airEsc(normalizedSearchValue)}", LOWER(SUBSTITUTE(SUBSTITUTE({型式}, "-", ""), " ", "")))`;
      }
      fetch(`https://api.airtable.com/v0/${airtableBaseId}/${airtableCarTableName}?filterByFormula=${encodeURIComponent(filterFormula)}`, { headers: { Authorization: `Bearer ${airtableApiKey}` } })
        .then(response => response.json())
        .then(data => {
          const recs = (data.records || []).map(r => r.fields);
          if (recs.length > 0) {
            WUWA_CTX.lastVehicleRecords = recs.slice();
            resultsContainer.innerHTML = '<div class="p-tab-head"><h2 class="p-tab-head__title">車両一覧</h2><p class="p-tab-head__text">以下の車両が見つかりました。</p></div><ul class="car-details"></ul>';
            recs.forEach((fields, index) => appendCarDetail(fields, index));
            saveSnapshot('vehicleList');

            WUWA_NAV.push(() => {
              const el = document.getElementById('car-search-results');
              if (el) el.innerHTML = '';
            });

          } else {
            resultsContainer.innerHTML = '<p>該当する車両が見つかりませんでした。</p>';
            saveSnapshot('vehicleNames');
          }
          WUWA_NAV.updateBtn();
        })
        .catch(() => { resultsContainer.innerHTML = '<p class="u-searching u-searching--error">エラーが発生しました。もう一度お試しください。</p>'; });
    }
  }

  if (form && resultsContainer) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      let searchValue = ''; let searchField = '';
      const activeTab = document.querySelector('.tab-content.active'); if (!activeTab) { return; }

      if (activeTab.id === 'tab-katashiki-ruibetsu') {
        const ruibetsuInput = document.getElementById('car-ruibetsu');
        const katashikiInput = document.getElementById('car-katashiki');
        if (ruibetsuInput && katashikiInput) {
          const ruibetsuValue = ruibetsuInput.value.trim();
          const katashikiValue = katashikiInput.value.trim();
          if (ruibetsuValue && katashikiValue) { searchValue = { ruibetsuValue, katashikiValue }; searchField = '型式指定番号 × 類別区分番号'; }
          else { resultsContainer.innerHTML = '<p class="u-searching">型式指定番号と類別区分番号の両方を入力してください。</p>'; return; }
        }
      } else if (activeTab.id === 'tab-katashiki') {
        const carCodeInput = document.getElementById('car-code'); if (carCodeInput) { searchValue = carCodeInput.value.trim(); searchField = '型式'; }
      } else if (activeTab.id === 'tab-car-name') {
        const carNameInput = document.getElementById('car-name'); if (carNameInput) { searchValue = carNameInput.value.trim(); searchField = '車両名'; }
      } else if (activeTab.id === 'tab-maker-name') {
        const makerNameInput = document.getElementById('maker-name'); if (makerNameInput) { searchValue = makerNameInput.value.trim(); searchField = 'メーカー名'; }
      }
      if (searchValue && searchField) { fetchCarDetails(searchValue, searchField); }
    });
  }
});

// ====== Snapshot (persist & restore across PDP navigation/back) ======
function detectCurrentView() {
  const resultsContainer = document.getElementById('car-search-results');
  if (!resultsContainer) return 'vehicleNames';
  if (resultsContainer.querySelector('.car-details__relatedProducts .card')) return 'productResults';
  if (resultsContainer.querySelector('.car-details')) return 'vehicleList';
  if (resultsContainer.querySelector('.vehicle-names-container')) return 'vehicleNames';
  return 'vehicleNames';
}
function saveSnapshot(view = detectCurrentView()) {
  const resultsContainer = document.getElementById('car-search-results');
  const payload = {
    view,
    makerName: WUWA_CTX.makerName,
    vehicleNames: WUWA_CTX.vehicleNames,
    vehicleName: WUWA_CTX.vehicleName,
    lastVehicleRecords: WUWA_CTX.lastVehicleRecords,
    flow: WUWA_CTX.flow,
    resultsHTML: resultsContainer ? resultsContainer.innerHTML : '',
    ts: Date.now(),
    path: location.pathname + location.search
  };
  try { sessionStorage.setItem('WUWA_SNAPSHOT', JSON.stringify(payload)); } catch { }
}
function rehydrateCarDetailEventHandlers() {
  document.querySelectorAll('.car-detail').forEach((li) => {
    const uniqueId = li.id;
    const partsBtn = li.querySelector('.car-detail__select-parts');
    const optBtn = li.querySelector('.car-detail__select-option');
    const optSelect = li.querySelector(`#option-filter-${uniqueId}`);

    if (partsBtn) {
      partsBtn.addEventListener('click', () => {
        prepareBackForNewSearch(uniqueId);
        handleSelectPartsByCarCode(partsBtn.dataset.carId, uniqueId);
        saveSnapshot('productResults');
      });
    }
    if (optSelect) {
      optSelect.addEventListener('change', () => {
        const selected = optSelect.selectedOptions[0];
        const optName = selected?.dataset?.optname || '';
        if (optName === 'タイヤサイズ') { ensureTireMidSelect(uniqueId); } else { removeTireMidSelect(uniqueId); }
      });
    }
    if (optBtn) {
      optBtn.addEventListener('click', () => {
        prepareBackForNewSearch(uniqueId);
        clearSearchNotices(uniqueId);
        focusOnCar(uniqueId);
        const selected = optSelect?.selectedOptions?.[0];
        const selectedValue = selected?.value || '';
        const optionName = selected?.dataset?.optname || '';
        if (!selectedValue) return;
        const midSel = document.getElementById(`tire-midcategory-filter-${uniqueId}`);
        const tireMidHandle = (optionName === 'タイヤサイズ' && midSel) ? (midSel.value || '').trim().toLowerCase() : '';
        const rel = li.querySelector('.car-details__relatedProducts');
        rel.innerHTML = '';
        fetchProductsByOption(uniqueId, optionName, selectedValue, tireMidHandle).then(() => {
          saveSnapshot('productResults');
        });
      });
    }
    setupCategoryFilters(uniqueId);
  });
  window.WUWA_NAV.updateBtn();
}
function restoreSnapshot() {
  let raw = null;
  try { raw = sessionStorage.getItem('WUWA_SNAPSHOT'); } catch { }
  if (!raw) return false;
  let s = null;
  try { s = JSON.parse(raw); } catch { s = null; }
  if (!s) return false;

  const resultsContainer = document.getElementById('car-search-results');
  if (!resultsContainer) return false;

  WUWA_CTX.makerName = s.makerName;
  WUWA_CTX.vehicleNames = s.vehicleNames;
  WUWA_CTX.vehicleName = s.vehicleName;
  WUWA_CTX.lastVehicleRecords = s.lastVehicleRecords;
  WUWA_CTX.flow = s.flow;

  setActiveMakerButton(WUWA_CTX.makerName);

  if (s.view === 'vehicleNames') {
    if (Array.isArray(WUWA_CTX.vehicleNames)) {
      (window.WUWA_internal?.renderVehicleNameButtons || renderVehicleNameButtons)(WUWA_CTX.vehicleNames, WUWA_CTX.makerName);
      return true;
    }
    if (window.WUWA_internal?.fetchVehicleNamesByMaker && WUWA_CTX.makerName) {
      window.WUWA_internal.fetchVehicleNamesByMaker(WUWA_CTX.makerName);
      return true;
    }
    return false;
  }

  if (s.view === 'vehicleList') {
    if (Array.isArray(WUWA_CTX.lastVehicleRecords) && WUWA_CTX.lastVehicleRecords.length) {
      renderVehicleListFromRecords(WUWA_CTX.lastVehicleRecords, WUWA_CTX.makerName);
      // この中で「車名一覧へ戻る」をpush済み
      return true;
    }
    if (WUWA_CTX.makerName && WUWA_CTX.vehicleName) {
      fetchVehiclesByName(WUWA_CTX.makerName, WUWA_CTX.vehicleName);
      return true;
    }
    return false;
  }

  if (s.view === 'productResults') {
    resultsContainer.innerHTML = s.resultsHTML || '';
    rehydrateCarDetailEventHandlers();

    // 戻る1回目：車両一覧へ
    WUWA_NAV.push(() => {
      if (Array.isArray(WUWA_CTX.lastVehicleRecords) && WUWA_CTX.lastVehicleRecords.length) {
        renderVehicleListFromRecords(WUWA_CTX.lastVehicleRecords, WUWA_CTX.makerName);
      } else if (WUWA_CTX.makerName && WUWA_CTX.vehicleName) {
        fetchVehiclesByName(WUWA_CTX.makerName, WUWA_CTX.vehicleName);
      } else {
        const el = document.getElementById('car-search-results'); if (el) el.innerHTML = '';
      }
    });
    // 「車両一覧 → 車名一覧」への戻りは renderVehicleListFromRecords 側で push 済み

    window.WUWA_NAV.updateBtn();
    return true;
  }

  return false;
}

// 「商品カードをクリックして離脱」時にも最新スナップショットを保存
document.addEventListener('click', (e) => {
  const a = e.target.closest('a.card');
  if (a && a.getAttribute('href') && a.getAttribute('href').startsWith('/products/')) {
    saveSnapshot(detectCurrentView());
  }
});

// 履歴での戻り（bfcache含む）を検知して復元
window.addEventListener('pageshow', (e) => {
  const navEntry = performance.getEntriesByType('navigation')[0];
  const isBackForward = (navEntry && navEntry.type === 'back_forward') || e.persisted;
  if (isBackForward) {
    restoreSnapshot();
  }
});

// 念のためページ離脱時にも保存
window.addEventListener('pagehide', () => saveSnapshot(detectCurrentView()));

// ====== WUWA キャッシュを 1 日に 1 回クリアする ======
(function setupDailyWuwaCacheClear() {
  const ONE_DAY_MS = 24 * 60 * 60 * 1000;
  const LAST_CLEAR_KEY = 'WUWA_CACHE_LAST_CLEAR';

  try {
    const now = Date.now();
    const raw = localStorage.getItem(LAST_CLEAR_KEY);
    let shouldClear = true;

    if (raw) {
      const last = parseInt(raw, 10);
      if (!Number.isNaN(last) && now - last < ONE_DAY_MS) {
        // 前回クリアから 24h 経っていなければ何もしない
        shouldClear = false;
      }
    }

    if (!shouldClear) return;

    const toDelete = [];

    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (!key) continue;

      // キャッシュキーだけ削除
      if (
        key === 'wuwa_makers_v2' ||                 // メーカー一覧
        key.startsWith('wuwa_vehicle_names_')       // 車名一覧（メーカー別）
      ) {
        toDelete.push(key);
      }
    }

    toDelete.forEach((k) => localStorage.removeItem(k));

    // 最終クリア時刻を更新
    localStorage.setItem(LAST_CLEAR_KEY, String(now));
  } catch (e) {
    console.warn('WUWA daily cache clear failed:', e);
  }
})();